// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a:focus {
    border: none;
}

.link-validacao {
    background-color: #0aa9b5;
    color: white;
    padding: 14px 25px;
    border-radius: 25px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
}

.link-validacao:hover, .link-validacao:active {
    background-color: #fd7300;
}

.pagina-conteudo {
    padding: 10px 15px 10px 20px;
    overflow-y: scroll;
    height: 100vh;
}

.ml-2 {
    margin-left: 1rem;
}

.conteudo-superior-row {
    display: flex;
    justify-content: space-between;
    padding-bottom: 0.25rem;
    transform: translatex(-10px);

}

.pagina-titulo {
    font-family: UniSansThin;
    font-style: normal;
    font-weight: 250;
    font-size: 20px;
    line-height: 24px;
    color: var(--pAzul);
}

.button-enviar {  
    margin-left: 20px;    
    margin-top: 20px;
    display: flex;
}

.input-titulo-data-row {
    display: flex;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Historico-gra/Historico-visualizar/style.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,4BAA4B;;AAEhC;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":["a:focus {\n    border: none;\n}\n\n.link-validacao {\n    background-color: #0aa9b5;\n    color: white;\n    padding: 14px 25px;\n    border-radius: 25px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n}\n\n.link-validacao:hover, .link-validacao:active {\n    background-color: #fd7300;\n}\n\n.pagina-conteudo {\n    padding: 10px 15px 10px 20px;\n    overflow-y: scroll;\n    height: 100vh;\n}\n\n.ml-2 {\n    margin-left: 1rem;\n}\n\n.conteudo-superior-row {\n    display: flex;\n    justify-content: space-between;\n    padding-bottom: 0.25rem;\n    transform: translatex(-10px);\n\n}\n\n.pagina-titulo {\n    font-family: UniSansThin;\n    font-style: normal;\n    font-weight: 250;\n    font-size: 20px;\n    line-height: 24px;\n    color: var(--pAzul);\n}\n\n.button-enviar {  \n    margin-left: 20px;    \n    margin-top: 20px;\n    display: flex;\n}\n\n.input-titulo-data-row {\n    display: flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
